module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/3_f2123428a6271f6faa306edb6ad2cc6b.png";